export type DeployEnv = 'local' | 'develop' | 'prod' | 'test' | 'staging'

const pageSizeOptions = [10, 20, 50, 100]

const currentEnv = (import.meta.env.ENV as DeployEnv) || 'local'

const prodConfig = {
  appName: '',
  apiEndpoint: import.meta.env.VITE_ENDPOINT_URL,
  apiAWS: import.meta.env.VITE_AWS_URL,
  tokenKey: 'accessToken',
  adminAuthKey: 'token',
  pageSizeOptions,
  defaultPageSize: pageSizeOptions[0],
  defaultDateWithoutSeparators: 'YYYYMMDD',
  defaultDateFormat: 'YYYY-MM-DD',
  defaultDateMonth: 'MM/DD',
  defaultTimeFormat: 'HH:mm',
  defaultMonthFormatForReport: 'YYYYMM',
  defaultMonthFormat: 'MM/YYYY',
  defaultDateTimeFormat: 'YYYY-MM-DD HH:mm',
  defaultDateTimeFormatA: 'YYYY-MM-DD HH:mm A',
  dafaultTimeFormat: 'HH:mm A',
  defaultStringifyFormat: 'YYYY-MM-DDTHH:mm:ss',
  dateMonthYearFormat: 'YYYY-MM-DD',
  bucket: '',
  cdn: '',
  currentEnv,
  defaultListParams: { page: 0, size: 10, sort: 'created_at,desc' }
}

const config = {
  local: {
    ...prodConfig
  },
  develop: {
    ...prodConfig
  },
  staging: {
    ...prodConfig
  },
  prod: {
    ...prodConfig
  },
  test: {
    ...prodConfig
  }
}

export const appConfig = config[currentEnv]

export function initSentry() {
  if (currentEnv === 'local') return
}
